"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _QuestionComponent = require("./QuestionComponent");
Object.keys(_QuestionComponent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QuestionComponent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _QuestionComponent[key];
    }
  });
});